var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 14.5096 22.1596 16.8229 20.7449 18.6738L19.5356 17.4645C18.5979 16.5268 17.3261 16 16 16H8.00002C6.67394 16 5.40217 16.5268 4.46449 17.4645L3.25513 18.6738C1.8404 16.8229 1 14.5096 1 12ZM7 10C7 7.23858 9.23858 5 12 5C14.7614 5 17 7.23858 17 10C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60968 20.1477C6.56247 21.92 9.15512 23 12 23C14.8449 23 17.4375 21.92 19.3903 20.1477L18.1213 18.8787C17.5587 18.3161 16.7957 18 16 18H8.00002C7.20438 18 6.44131 18.3161 5.8787 18.8787L4.60968 20.1477Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.485c3dc2d78d9ffc2b2202945e733f53.svg";
export { ForwardRef as ReactComponent };